import { Plant } from '@types'

import React, { FC } from 'react'
import { Controller } from 'react-hook-form'

import { DashboardLink, Inputs, ImagePicker } from '@components'
import { ROUTES } from '@constants'
import Switch from '../common/Switch/Switch'

type PlantFormProps = {
  plant: Plant
  isAllowUpdateStatus?: boolean
  onClearImage: () => void
  handleSubmit: () => void
  validateInputImage: (e) => void
}

const PlantForm: FC<PlantFormProps> = ({ handleSubmit, plant, validateInputImage, onClearImage, isAllowUpdateStatus }) => {
  const header = plant.name || 'Plant Name'
  return (
    <React.Fragment>
      <div className='head'>{header}</div>
      <div className='content'>
        <div className='box'>
          <div className='box-logo'>
            <div className='text-logo'>Plant Logo</div>
            <div className='text-size-picture'>
              Maximum image 1 MB.
              <br /> Allowed file types: png, jpg, jpeg.
            </div>
          </div>
          <Controller
            name='image'
            defaultValue={plant.image_base64}
            render={({ field }) => {
              return (
                <ImagePicker
                  value={field.value}
                  clearImg={onClearImage}
                  onChange={(e) => {
                    field.onChange(e)
                    validateInputImage(e)
                  }}
                />
              )
            }}
          />
        </div>
        <DashboardLink url={`${window.location.origin}${ROUTES.DASHBOARD}?${plant.plant_id}`} />
        <Inputs name={'reimbursement'} label={'Reimbursement / Currency'} unit={'Baht/kWh'} />
        <Inputs name={'co2'} label={'Co2 Avoided (Factor)'} unit={'g/kWh'} />
        {
          isAllowUpdateStatus && (
          <Switch
            name={'isActive'}
            label={'Dashboard Access'}
              description={'Allow customers to view the Dashboard via URL'}
              helperText={'When disabled, customers can not open the Dashboard via the link.'}
          />
          )
        }
      </div>
      <div className='btn-save' onClick={handleSubmit}>
        <div className='text'>Save</div>
      </div>
    </React.Fragment>
  )
}

export default PlantForm
